// This file was generated using `pay js:run gql-v1 --type=fragment --name=StripeAccountCapabilitiesRequirementsArk --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument, GraphQlFragmentUnion} from '@sail/data';
import type {
  Exact,
  OpenapiAccountCapabilityRequirementsDisabledReasonEnum,
} from '@stripe-internal/data-v1/schema/types';
import type {V1PermissionToken} from '@stripe-internal/data-v1/types';
import {stripeAccountRequirementsAlternativeArkFragment} from './stripeAccountRequirementsAlternativeArkFragment';
import {stripeAccountRequirementsErrorArkFragment} from './stripeAccountRequirementsErrorArkFragment';

import type {StripeAccountRequirementsAlternativeArkFragmentData} from './stripeAccountRequirementsAlternativeArkFragment';
import type {StripeAccountRequirementsErrorArkFragmentData} from './stripeAccountRequirementsErrorArkFragment';

const doc = gql`
  fragment StripeAccountCapabilitiesRequirementsArkFragment on OpenapiAccountCapabilityRequirements {
    alternatives {
      ...StripeAccountRequirementsAlternativeArkFragment
    }
    current_deadline
    currently_due
    disabled_reason
    errors {
      ...StripeAccountRequirementsErrorArkFragment
    }
    eventually_due
    past_due
    pending_verification
  }

  ${stripeAccountRequirementsAlternativeArkFragment}
  ${stripeAccountRequirementsErrorArkFragment}
`;

export const stripeAccountCapabilitiesRequirementsArkFragment: StripeAccountCapabilitiesRequirementsArkFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type StripeAccountCapabilitiesRequirementsArkFragmentData = {
  readonly __typename: 'OpenapiAccountCapabilityRequirements';
  readonly current_deadline: number | null;
  readonly currently_due: ReadonlyArray<string>;
  readonly disabled_reason: OpenapiAccountCapabilityRequirementsDisabledReasonEnum | null;
  readonly eventually_due: ReadonlyArray<string>;
  readonly past_due: ReadonlyArray<string>;
  readonly pending_verification: ReadonlyArray<string>;
  readonly alternatives: ReadonlyArray<
    GraphQlFragmentUnion<
      {readonly __typename: 'OpenapiAccountRequirementsAlternative'},
      [StripeAccountRequirementsAlternativeArkFragmentData]
    >
  > | null;
  readonly errors: ReadonlyArray<
    GraphQlFragmentUnion<
      {readonly __typename: 'OpenapiAccountRequirementsError'},
      [StripeAccountRequirementsErrorArkFragmentData]
    >
  >;
};

export type StripeAccountCapabilitiesRequirementsArkFragmentVariables = Exact<{
  [key: string]: never;
}>;

const stripeAccountCapabilitiesRequirementsArkFragmentPermissions = {
  ...stripeAccountRequirementsAlternativeArkFragment.permissions,
  ...stripeAccountRequirementsErrorArkFragment.permissions,
} as const;

doc.permissions = stripeAccountCapabilitiesRequirementsArkFragmentPermissions;

export type StripeAccountCapabilitiesRequirementsArkFragmentPermissions =
  V1PermissionToken<
    typeof stripeAccountCapabilitiesRequirementsArkFragmentPermissions
  >;

export type StripeAccountCapabilitiesRequirementsArkFragmentDocument =
  GraphQlDocument<
    StripeAccountCapabilitiesRequirementsArkFragmentData,
    StripeAccountCapabilitiesRequirementsArkFragmentVariables,
    StripeAccountCapabilitiesRequirementsArkFragmentPermissions
  >;
